import { Icon } from "web/components"

export default function ErrorMessage({ message }) {
  return (
    <div className="bottom-4 m-4 rounded-md bg-red-100 p-4 text-red-800">
      <div className="flex">
        <div className="shrink-0">
          <Icon name="x-circle" />
        </div>
        <div className="ml-3">
          <div className="text-sm font-medium">{message}</div>
        </div>
      </div>
    </div>
  )
}
